import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { PopupApiAdapter } from '../adapters';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { CreatePopupRequest } from '../models';

export const useCreatePopup = () => {
  const { toast } = useToast();
  const { t } = useTranslation('popups');
  const queryClient = useQueryClient();
  const adapter = new PopupApiAdapter(createHttpClient(apiClientWH));

  return useMutation({
    mutationFn: (popup: CreatePopupRequest) => adapter.createPopup(popup),
    onSuccess: () => {
      toast({
        title: t('toast.popupCreated'),
        description: t('toast.popupCreatedDescription'),
        variant: 'default',
      });

      queryClient.invalidateQueries({ queryKey: ['popups'] });
    },
    onError: (error) => {
      toast({
        title: t('toast.errorCreating'),
        description: error instanceof Error ? error.message : 'Unknown error',
        variant: 'destructive',
      });
    },
  });
};
